import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { appTheme } from './theme';
import App from './App';
import { store } from './store/store';
import { loadEnvConfig } from './services/envConfig';
import { loadWvBrandingConfig } from './services/wvBrandingConfig';
import { LocaleProvider } from './locale/LocaleProvider';
import { mountAccessibilityWidget } from './a11y/delasoftAccessibility';
import { clearLegacyAccessibilityState } from './a11y/clearLegacyAccessibilityState';
import './styles/global.css';
/**
 * Both must run before the widget's settings-restore fires on mount — see
 * `clearLegacyAccessibilityState.ts`. The widget mounts outside React entirely
 * (its own Shadow DOM root on `<html>`), loaded at runtime as a Module Federation
 * remote — see `a11y/delasoftAccessibility.ts` for why.
 *
 * Not awaited: the remote is fetched over the network, and the portal must paint
 * without waiting on it. It shares this app's React via the federation share
 * scope, so mounting before `createRoot` below is safe.
 */
clearLegacyAccessibilityState();
mountAccessibilityWidget();
/** Warm caches so NavBar and WV asset paths are available on first paint. */
void Promise.all([loadEnvConfig(), loadWvBrandingConfig()]).then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(React.StrictMode, { children: _jsx(ThemeProvider, { theme: appTheme, children: _jsxs(LocaleProvider, { children: [_jsx(CssBaseline, {}), _jsx(Provider, { store: store, children: _jsx(HashRouter, { children: _jsx(App, {}) }) })] }) }) }));
});
